import { Pipe, PipeTransform } from '@angular/core';
import { AccountMoveModel } from 'src/app/shared/store/accounting/types';

@Pipe({
  name: 'accountmovesamount',
  standalone: false,
})
export class AccountMovesAmountPipe implements PipeTransform {
  transform(values?: AccountMoveModel[]): number {
    let result = 0;

    values?.forEach((accountMoves) => {
      accountMoves.accountMoveLines.forEach((accountMoveLines) => {
        if (!!accountMoveLines.unitPriceClientView)
          result +=
            accountMoveLines.unitPriceClientView * accountMoveLines.quantity;
      });
    });

    return result;
  }
}
